<div class="container-style">
  <a href="{{componentData.url}}">{{componentData.name}}</a>
</div>
